import namespace from "@rdfjs/namespace";
const builder = namespace("https://linked.art/ns/terms/");
export const strict = builder;
export const loose = builder;
